import type { ElementType, ComponentPropsWithoutRef } from "react";

type DropdownProperties<T extends ElementType = "span"> = {
  as?: T;
  className?: string | undefined;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className">;

export const HeaderMenuItem = <T extends ElementType = "span">({
  children,
  as,
  className = "",
  ...properties
}: DropdownProperties<T>) => {
  const Component = as ?? "span";
  return (
    <Component
      className={`
        peer relative flex grow flex-col px-4 pt-2 pb-4 text-start text-l-body
        transition-colors

        group-has-focus-visible/dropdown:bg-background-surface-variant-low
        group-has-focus-visible/dropdown:text-foreground-primary-variant

        focus-visible:outline-1 focus-visible:outline-offset-[3px]
        focus-visible:outline-border-variant-lowest

        aria-expanded:bg-background-surface-variant-low
        aria-expanded:text-foreground-primary-variant

        md:flex-row md:items-center md:justify-center md:gap-2 md:p-0
        md:text-s-heading md:transition-none

        md:group-has-focus-visible/dropdown:bg-inherit
        md:group-has-focus-visible/dropdown:text-inherit

        md:after:absolute md:after:bottom-0 md:after:h-1 md:after:w-0
        md:after:bg-background-accent md:after:transition-all
        md:after:content-['_']

        md:group-focus-within:after:w-full

        md:group-focus-within/dropdown:after:w-full

        hover:md:after:w-full

        focus-visible:md:outline-none

        focus-visible:md:after:w-full

        md:aria-expanded:bg-transparent
        md:aria-expanded:text-foreground-on-primary

        aria-expanded:md:after:w-full

        ${className}
      `}
      {...properties}
    >
      {children}
    </Component>
  );
};
